module.exports = __webpack_public_path__ + "static/media/ksnhorizon.625aa04c.png";